import React, { Component } from "react";
import moment from 'moment';
import {
    VictoryChart,
    VictoryAxis,
    VictoryLine,
    VictoryTheme,
} from "victory";


// Lowest observed or forecast reading, minus a fixed offset, used as the
// y-axis floor. Clamped to a small positive number because this chart's
// y-axis is log-scaled, where a domain minimum of <= 0 is undefined.
const Y_AXIS_OFFSET = 5;
const LOG_AXIS_FLOOR = 0.1;

function flowAxisMinimum(readings) {
    const lowest = readings.reduce((min, p) => {
        // Number(null) and Number('') are 0, not NaN, so missing readings
        // have to be rejected before the numeric conversion.
        if (!p || p.value === null || p.value === undefined || p.value === '') {
            return min;
        }

        const value = Number(p.value);
        return isFinite(value) ? Math.min(min, value) : min;
    }, Infinity);

    if (lowest === Infinity) {
        return LOG_AXIS_FLOOR;
    }

    return Math.max(lowest - Y_AXIS_OFFSET, LOG_AXIS_FLOOR);
}



class SmallFlowChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            observedData: [],
            forecastData: [],
            totalData: [],
            tickValues: [],
            yMin: LOG_AXIS_FLOOR,
        };
    }

    setChartData() {
        if (this.props.data && this.props.data.length > 1) {

            // create formatted date object for observed
            const observed = this.props.data.map(p => {
                p.Date = moment(p.dateTime).format();
                p.Date = new Date(p.Date);
                return p;
            });

            // create formatted date object for observed
            const forecast = this.props.forecastData.map(p => {
                p.Date = moment(p.dateTime).format();
                p.Date = new Date(p.Date);
                return p;
            });

            // total readings
            const total = observed.concat(forecast);

            this.setState({ observedData: observed });
            this.setState({ forecastData: forecast });
            this.setState({ totalData: total });

            // y-axis floor: 5 below the lowest reading across both series
            this.setState({ yMin: flowAxisMinimum(total) });


            // set tick marks to occur daily from day of
            // first observed reading to last forecast reading
            const startDay = moment(total[0].Date);
            const endDay = moment(total[total.length - 1].Date);
            const timeline = endDay.diff(startDay, 'days');

            this.setState({ startDay, endDay });

            const newTickValues = []

            for (let i = 0; i < timeline; i++) {
                var newTickDay = moment(startDay).add(1, 'days')
                newTickValues.push(moment(newTickDay).format('MMM D'))

            }

            this.setState({ tickValues: newTickValues });
        }
    }

    componentDidMount() {

        if (this.props.forecastData && this.props.forecastData.length > 0 ) {
            this.setChartData();
        }

    }

    // if observed or forecast data changes, update and set data state again
    componentDidUpdate(prevProps) {

        if ((prevProps.forecastData !== this.props.forecastData) || (prevProps.observedData !== this.props.observedData)) {
            this.setChartData();
        }

    }
    

    render() {

        return (
            <div>

                <VictoryChart
                    padding={{ top: 10, left: 90, right: 50, bottom: 60 }}
                    minDomain={{ y: this.state.yMin }}
                    width={700}
                    height={350}
                    scale={{ y: "log", x: "time" }}
                    theme={VictoryTheme.material}
                >
                    <VictoryAxis dependentAxis
                        scale={{ y: "log" }}
                        orientation="left"
                        standalone={false}
                        tickFormat={(t) => `${Math.round(t)} cfs`}
                        tickCount={5}
                        style={{
                            tickLabels: { fontSize: 20, padding: 5 }
                        }}
                    />
                    <VictoryAxis
                        scale="time"
                        style={{
                            tickLabels: { fontSize: 20, padding: 5 }
                        }}
                    // tickValues={this.setState.tickValues}
                    // tickFormat={x => moment(x).format('MMM D')}
                    />
                    <VictoryLine
                        style={{
                            data: { stroke: "#1f89c7", strokeWidth: 1 }
                        }}
                        data={this.state.observedData}
                        x="Date"
                        y={"value"}
                    />
                    <VictoryLine
                        style={{
                            data: { stroke: "#9a9696", strokeWidth: 1 }
                        }}
                        data={this.state.forecastData}
                        x="Date"
                        y={"value"}
                    />


                </VictoryChart>
            </div>
        );
    }
}

export default SmallFlowChart;


// WEBPACK FOOTER //
// ./src/components/SmallFlowchart/index.js